export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7088a4fb613de280fbb2d5f9bffc7beee79587d327&name=pushAdClickData!'